import React from 'react';

import { v4 } from 'uuid';

import { useCarousel } from 'hooks/useCarousel';
import { useQuickAcces } from 'hooks/useQuickAcces';

export const QuickAccess = () => {
  const { quickAccesContent } = useQuickAcces();

  const { containerRef, carouselState } = useCarousel({
    cards: quickAccesContent?.list ?? [],
    className: 'category-benefits-card',
  });

  const isActiveMenu = (menu: string) => {
    const { pathname } = window.location;

    return pathname === menu ? ' active' : '';
  };

  if (!quickAccesContent) return null;

  return (
    <div className="quick-access">
      <div className="quick-access__title">{quickAccesContent.title}</div>
      <div className="quick-access__list" ref={containerRef}>
        {quickAccesContent.list.map(({ label, image, link }, index) => {
          const className = 'quick-access__list__item';
          const isCardSmiles = index === quickAccesContent.list.length - 1;
          const classActive = isActiveMenu(String(link));

          return (
            <a
              className={`${className}${isCardSmiles ? ` ${className}--smiles` : ''}${classActive}`}
              key={v4()}
              href={link}
            >
              {image && <img src={image} className="icon" alt={label} />}
              <span>{label}</span>
            </a>
          );
        })}
      </div>

      <div className="mobile-dots">
        {quickAccesContent.list.map((_item, index) => (
          <span className={`mobile-dots__dot${index + 1 === carouselState.current ? ' current' : ''}`} key={v4()} />
        ))}
      </div>
    </div>
  );
};
